
const t = {
    trailer_type: "Tréler",
    vehicle: "Jármű",
    job_type: "Munka típusa",
    employment_type: "Munkavállalás típusa",
    type: "Típus",
    additional_licenses: "Egyéb képesítések",
    additional_passes: "Egyéb bizonyítvány",
    beginner: "Kezdő",
    language: "Beszélt nyelvek",
    license_type: "Jogosítvány",
    pav: "PÁV",
    place_of_work: "Munkavégzés helye",
    salary: "Fizetés",
    salary_duration: "Fizetés frekvencia"
  };
  

  
  export default t;
  